"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var _default = {
  PropTypes: {
    items: _propTypes.default.array.isRequired,
    value: (0, _propTypes.oneOfType)([_propTypes.default.string, _propTypes.default.number]),
    label: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    validateStatus: (0, _propTypes.oneOf)([_constant2.VALIDATE_STATUS_SUCCESS, _constant2.VALIDATE_STATUS_ERROR]),
    disabled: _propTypes.default.bool,
    disableScroll: _propTypes.default.bool,
    isMobile: _propTypes.default.bool,
    width: _propTypes.default.string,
    height: _propTypes.default.string,
    onChange: _propTypes.default.func,
    renderActiveLabel: _propTypes.default.func,
    renderDisplayValue: _propTypes.default.func,
    renderOptionLabel: _propTypes.default.func,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    isMobileV2: _propTypes.default.bool,
    closeOnOutsideClick: _propTypes.default.bool,
    withLabelOpacity: _propTypes.default.bool,
    isShowChildAgeInput: _propTypes.default.bool,
    inputIndex: _propTypes.default.number,
    currentSelect: _propTypes.default.number,
    setCurrentSelect: _propTypes.default.func,
    disableActiveLabel: _propTypes.default.bool,
    noBorder: _propTypes.default.bool,
    maxHeight: _propTypes.default.number,
    enablePaxAgeUpdate: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    width: '100%',
    height: '48px',
    isMobile: false,
    accessible: true,
    disableScroll: false,
    onChange: function onChange() {},
    setCurrentSelect: function setCurrentSelect() {},
    isMobileV2: false,
    closeOnOutsideClick: true,
    withLabelOpacity: false,
    isShowChildAgeInput: false,
    disableActiveLabel: false,
    noBorder: false,
    enablePaxAgeUpdate: false
  }
};
exports.default = _default;